import { BulmaNavButtons } from "Components/BulmaNavButtons";
import { Horizontal } from "Components/Horizontal";
import { Section } from "Components/Section";
import { SmallIcon } from "Components/SmallIcon";
import { Program } from "SharedConstants";
import { ReactStandardAIInputModel } from "SharedConstants/Schema";
import { appendQueryObject } from "Tools";
import { MVCSubmitButton } from "Views/MVCForm";

export function StandardAIInput(props: ReactStandardAIInputModel) {
  const hasAnyAIs = props.ExistingAIListWithCosts.length > 0;

  return (
    <>
      <div
        style={{ margin: "auto", maxWidth: "36em" }}
        dangerouslySetInnerHTML={props.Header}
      />
      <AddAIButton {...props} />
      {props.AllowIndependentContractor && (
        <Horizontal>
          <div className="is-italic">
            Staff members are included for no extra charge. Please note that
            independent contractors are not considered staff, however they may
            be added as Additional Insured parties at a cost of{" "}
            {props.IndependentContractorAIFeeText} each.
            {props.Program === Program.Npfl && (
              <>
                {" "}
                The National Pro Fitness League is automatically added as an
                Additional Insured party.
              </>
            )}
          </div>
        </Horizontal>
      )}
      {hasAnyAIs && <ExistingAISection {...props} />}
      <BulmaNavButtons
        backCaption="Back"
        continueCaption={
          hasAnyAIs ? "Continue" : "Continue Without Additional Insureds"
        }
        isDisabled={props.isSubmitting}
      />
    </>
  );
}

function AddAIButton(props: ReactStandardAIInputModel) {
  return props.CanAddAI ? (
    <div className="field is-grouped is-grouped-centered">
      <div className="control">
        <MVCSubmitButton className="button" value={props.AddAIText}>
          <SmallIcon name="fa-plus" />
          <span>{props.AddAIText}</span>
        </MVCSubmitButton>
      </div>
    </div>
  ) : (
    <Horizontal>
      The maximum number of Additional Insureds have been added. To add more,
      please contact us using the information below.
    </Horizontal>
  );
}

function ExistingAISection(props: ReactStandardAIInputModel) {
  return (
    <Section
      title={
        <span style={{ textDecoration: "underline" }}>
          Current Additional Insureds
        </span>
      }
    >
      <Horizontal>
        <div className="field">
          <ol style={{ listStyle: "none" }}>
            {props.ExistingAIListWithCosts.map((e, i) => (
              <li
                key={e.StandardAdditionalInsuredID}
                style={{ marginBottom: "0.5em" }}
              >
                <strong>{e.Name}</strong>
                <div>
                  {e.Address1} {e.Address2}
                </div>
                <div>
                  {e.City}, {e.State} {e.ZipCode}
                </div>
                <div>{e.Email || "(No email)"}</div>
                <div>Relationship: {e.Relationship}</div>
                {e.HasNonContrib && (
                  <div>Includes Primary and Non-Contributory Endorsement</div>
                )}
                {e.HasWaiverOfSubrogation && (
                  <div>Includes Waiver of Subrogation Endorsement</div>
                )}
                {e.HasCG2026Endorsement && (
                  <div>Includes CG 20 26 Endorsement</div>
                )}
                <div>Cost: {e.CostText}</div>
                {!e.IsMandatory && (
                  <a
                    href={
                      appendQueryObject(props.RemoveAIUrlBase, {
                        AIID: e.StandardAdditionalInsuredID,
                      }).href
                    }
                  >
                    (Remove)
                  </a>
                )}
              </li>
            ))}
          </ol>
          <div style={{ marginTop: "1em" }}>
            <span className="has-text-weight-bold">
              Total Cost for Additional Insureds:
            </span>{" "}
            {props.TotalAICostText}
          </div>
        </div>
      </Horizontal>
    </Section>
  );
}
